var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Database(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LkaBH78Qy0LlLxZFYVKUda",
    x1: 8,
    x2: 40,
    y1: 35.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LkaBH78Qy0LlLxZFYVKUda)",
    d: "M40,28H8c0,0,0,10.271,0,11c0,2.209,7.163,4,16,4s16-1.791,16-4C40,38.271,40,28,40,28z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LkaBH78Qy0LlLxZFYVKUdb",
    x1: 8,
    x2: 40,
    y1: 25.5,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LkaBH78Qy0LlLxZFYVKUdb)",
    d: "M40,18H8c0,0,0,10.271,0,11c0,2.209,7.163,4,16,4s16-1.791,16-4C40,28.271,40,18,40,18z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LkaBH78Qy0LlLxZFYVKUdc",
    x1: 8,
    x2: 40,
    y1: 15,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LkaBH78Qy0LlLxZFYVKUdc)",
    d: "M40,8H8c0,0,0,9.756,0,10.5c0,1.933,7.163,3.5,16,3.5s16-1.567,16-3.5C40,17.756,40,8,40,8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LkaBH78Qy0LlLxZFYVKUdd",
    x1: 8,
    x2: 40,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a4eb"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 8,
    fill: "url(#LkaBH78Qy0LlLxZFYVKUdd)",
    rx: 16,
    ry: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Database);
export default __webpack_public_path__ + "static/media/icons8-database.827ddc2a8676fc2e4a24b761cc53c324.svg";
export { ForwardRef as ReactComponent };